import { render, staticRenderFns } from "./AdminMonthlyReportsRoute.vue?vue&type=template&id=310e5b64"
import script from "./AdminMonthlyReportsRoute.vue?vue&type=script&lang=js"
export * from "./AdminMonthlyReportsRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports